import React from 'react';
import styled, { keyframes } from 'styled-components';

const typingBounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1.2);
    opacity: 1;
  }
`;

const TypingContainer = styled.div`
  margin: 0.5rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

const AIActionBubble = styled.div`
  padding: 0.75rem 1rem;
  width: fit-content;
  max-width: 80%;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.875rem;
  font-style: italic;
  background-color: ${({ theme }) => theme.colors.surfaceSecondary};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  border-left: 3px solid ${({ theme }) => theme.colors.primary};
`;

const StatusMessages = styled.div`
  margin-bottom: 0.5rem;
  
  p {
    margin: 0 0 0.25rem 0;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const TypingIndicatorContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 0.5rem;
`;

const Dot = styled.span`
  height: 6px;
  width: 6px;
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  display: inline-block;
  margin: 0 2px;
  animation: ${typingBounce} 1.4s infinite both;

  &:nth-child(1) {
    animation-delay: 0s;
  }

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

interface TypingIndicatorProps {
  statusMessages?: string[];
  showIndicator?: boolean;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ 
  statusMessages = [], 
  showIndicator = true 
}) => {
  const getStatusMessageHTML = () => {
    if (!statusMessages.length && !showIndicator) {
      return null;
    }
    
    return (
      <AIActionBubble>
        {statusMessages.length > 0 && (
          <StatusMessages>
            {statusMessages.map((msg, index) => (
              <p key={index}>{msg}</p>
            ))}
          </StatusMessages>
        )}
        {showIndicator && (
          <TypingIndicatorContainer>
            <Dot />
            <Dot />
            <Dot />
          </TypingIndicatorContainer>
        )}
      </AIActionBubble>
    );
  };

  return (
    <TypingContainer>
      {getStatusMessageHTML()}
    </TypingContainer>
  );
};

export default TypingIndicator;